import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import { useState } from "react";
import { ATargetBlank } from "../../../../../../../shared/Link/ATargetBlank";
import { User } from "../../../../../../../shared/User/types";
import { AddLinksDialog, fetchUpdateBioLinks } from "./AddLinksDialog";
import { getLinkText } from "./getLinkText";

export function BioLinks({
    isAddLinkDialogOpen,
    closeDialog,
    user,
}: {
    isAddLinkDialogOpen: boolean;
    closeDialog: () => void;
    user: User;
}) {
    const c = useStyles();
    const [submitting, setSubmitting] = useState("");

    return (
        <>
            <div className={c.linkContainer}>
                {user.bioLinks.map(({ url, title }) => {
                    if (submitting === url) {
                        return null;
                    }
                    const linkText = getLinkText(title, url);

                    return (
                        <Card className={c.linkCard} key={url} elevation={3}>
                            <ATargetBlank href={url} className={c.link}>
                                {linkText}
                            </ATargetBlank>

                            <IconButton
                                className={c.deleteIconButton}
                                onClick={async () => {
                                    setSubmitting(url);
                                    await fetchUpdateBioLinks(
                                        user.userId,
                                        user.bioLinks.filter(l => l.url !== url)
                                    );
                                    setSubmitting("");
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Card>
                    );
                })}
            </div>
            <AddLinksDialog
                isAddLinkDialogOpen={isAddLinkDialogOpen}
                closeDialog={closeDialog}
                user={user}
            />
        </>
    );
}
const useStyles = makeStyles({
    linkContainer: { display: "flex", flexWrap: "wrap", gap: 5, width: "100%" },
    link: {
        fontSize: "small",
    },
    linkCard: {
        marginTop: 4,
        whiteSpace: "nowrap",
        padding: "1px 5px",
    },
    deleteIconButton: {
        backgroundColor: "white",
        maxHeight: 17,
        maxWidth: 17,
        position: "relative",
        left: 4,
    },
});

